export default __webpack_public_path__ + "static/media/director-photo.ee95fb0f.png";